import LayoutFull from '@/layouts/full/LayoutFull.vue'

export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/user/home/index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/contactUs-user',
    name: 'contactUs-user',
    component: () => import('@/views/user/home/contactUs.vue'),
    meta: {
      layout: 'full',
      requiresAuth: true,
    },
  },
  {
    path: '/telkom-product-tree',
    name: 'telkom-product-tree',
    component: () => import('@/views/user/tree/Index.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/podcast',
    name: 'podcast',
    component: () => import('@/views/user/podcast/Index.vue'),
    meta: {
      pageTitle: 'Podcast',
      breadcrumb: [
        {
          text: 'Podcast',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/podcast/:id',
    name: 'podcast-detail',
    component: () => import('@/views/user/podcast/Detail.vue'),
    meta: {
      pageTitle: 'Podcast Detail',
      breadcrumb: [
        {
          text: 'Podcast',
          active: true,
        },
      ],
      requiresAuth: true,
    },
    props: route => ({ podcast: route.params }),
  },

  {
    path: '/nodin',
    name: 'nodin',
    component: () => import('@/views/user/nodin/NotaDinas.vue'),
    meta: {
      pageTitle: 'Nota Dinas',
      breadcrumb: [
        {
          text: 'Nota Dinas',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/flipbook/:category',
    name: 'Flipbook',
    component: () => import('@/views/user/product/FlipBook.vue'),
    meta: {
      pageTitle: 'Flip Book',
      breadcrumb: [
        {
          text: 'Flip Book',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-bookmark',
    name: 'product-bookmark',
    component: () => import('@/views/user/product/Bookmark.vue'),
    meta: {
      pageTitle: 'Bookmark',
      breadcrumb: [
        {
          text: 'Bookmark',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-comparison',
    name: 'product-comparison',
    component: () => import('@/views/user/product-comparison/index.vue'),
    meta: {
      pageTitle: 'Competitor Comparison',
      breadcrumb: [
        {
          text: 'Competitor Comparison',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/discussion/create',
    name: 'discussion-create',
    component: () => import('@/views/user/discussion/Create.vue'),
    meta: {
      pageTitle: 'Discussion',
      breadcrumb: [
        {
          text: 'Discussion',
          to: '/discussion',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/discussion/:key',
    name: 'discussion-detail',
    component: () => import('@/views/user/discussion/Detail.vue'),
    meta: {
      pageTitle: 'Discussion',
      breadcrumb: [
        {
          text: 'Discussion',
          to: '/discussion',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-request',
    name: 'product-request',
    component: () => import('@/views/user/request/Index.vue'),
    meta: {
      pageTitle: 'Product Request',
      breadcrumb: [
        {
          text: 'Product Request',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/segmen',
    name: 'product-stp-segment',
    component: () => import('@/views/user/product/IndexSTP.vue'),
    meta: {
      pageTitle: 'Product By STP',
      contentClass: 'product-stp-segment',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Segmentation',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/target',
    name: 'product-stp-target',
    component: () => import('@/views/user/product/IndexSTP.vue'),
    meta: {
      pageTitle: 'Product By STP',
      contentClass: 'product-stp-target',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Targeting',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/segmentation/detail/:key',
    name: 'product-segmentation-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Segmentation',
          to: '/product-stp/segmen',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/segmentation/faq/:key',
    name: 'product-stp-segmen-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Segmentation',
          to: '/product-stp/segmen',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/segmentation/compare-product/:key',
    name: 'segmen-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Segmentation',
          to: '/product-stp/segmen',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/segmentation/tarif/:key',
    name: 'product-segmen-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Segmentation',
          to: '/product-stp/segmen',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/segmentation/casestudy/:key',
    name: 'product-segmen-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Segmentation',
          to: '/product-stp/segmen',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/targeting/detail/:key',
    name: 'product-targeting-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Targeting',
          to: '/product-stp/target',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/targeting/faq/:key',
    name: 'product-stp-target-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Targeting',
          to: '/product-stp/target',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/targeting/compare-product/:key',
    name: 'target-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Targeting',
          to: '/product-stp/target',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/targeting/tarif/:key',
    name: 'product-target-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Targeting',
          to: '/product-stp/target',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-stp/targeting/casestudy/:key',
    name: 'product-target-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By STP',
        },
        {
          text: 'Targeting',
          to: '/product-stp/target',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/bundling',
    name: 'product-category-bundling',
    component: () => import('@/views/user/bundling/IndexBundling.vue'),
    meta: {
      pageTitle: 'Product Bundling',
      contentClass: 'product-category-bundling',
      breadcrumb: [
        {
          text: 'Product Bundling',
        },
        {
          text: 'Bundling',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/bundling/detail/:key',
    name: 'product-bundling-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product Bundling',
          to: '/bundling',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/bundling/faq/:key',
    name: 'product-bundling-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product Bundling',
          to: '/bundling',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/bundling/tarif/:key',
    name: 'product-bundling-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product Bundling',
          to: '/bundling',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/bundling/compare-product/:key',
    name: 'bundling-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product Bundling',
          to: '/bundling',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/bundling/casestudy/:key',
    name: 'product-bundling-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product Bundling',
          to: '/bundling',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/fitur',
    name: 'product-category-fitur',
    component: () => import('@/views/user/bundling/IndexBundling.vue'),
    meta: {
      pageTitle: 'Product by Category',
      contentClass: 'product-category-fitur',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Fitur',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/fitur/detail/:key',
    name: 'product-fitur-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Fitur',
          to: '/fitur',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/fitur/faq/:key',
    name: 'product-fitur-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Fitur',
          to: '/fitur',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/fitur/tarif/:key',
    name: 'product-fitur-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Fitur',
          to: '/fitur',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/fitur/compare-product/:key',
    name: 'fitur-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Fitur',
          to: '/fitur',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/fitur/casestudy/:key',
    name: 'product-fitur-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Fitur',
          to: '/fitur',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/produk',
    name: 'product-category-produk',
    component: () => import('@/views/user/bundling/IndexBundling.vue'),
    meta: {
      pageTitle: 'Product by Category',
      contentClass: 'product-category-produk',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Produk',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/produk/detail/:key',
    name: 'product-produk-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Produk',
          to: '/produk',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/produk/faq/:key',
    name: 'product-produk-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Produk',
          to: '/produk',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/produk/tarif/:key',
    name: 'product-produk-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Produk',
          to: '/produk',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/produk/compare-product/:key',
    name: 'produk-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Produk',
          to: '/produk',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/produk/casestudy/:key',
    name: 'product-produk-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Produk',
          to: '/produk',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/varian',
    name: 'product-category-varian',
    component: () => import('@/views/user/bundling/IndexBundling.vue'),
    meta: {
      pageTitle: 'Product by Category',
      contentClass: 'product-category-varian',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Varian',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/varian/detail/:key',
    name: 'product-varian-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Varian',
          to: '/varian',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/varian/faq/:key',
    name: 'product-varian-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Varian',
          to: '/varian',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/varian/tarif/:key',
    name: 'product-varian-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Varian',
          to: '/varian',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/varian/compare-product/:key',
    name: 'varian-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Varian',
          to: '/varian',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/varian/casestudy/:key',
    name: 'product-varian-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'Varian',
          to: '/varian',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/dtp',
    name: 'product-category-dtp',
    component: () => import('@/views/user/bundling/IndexBundling.vue'),
    meta: {
      pageTitle: 'Product by Category',
      contentClass: 'product-category-dtp',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'DTP',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/dtp/detail/:key',
    name: 'product-dtp-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'DTP',
          to: '/dtp',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/dtp/faq/:key',
    name: 'product-dtp-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'DTP',
          to: '/dtp',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/dtp/tarif/:key',
    name: 'product-dtp-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'DTP',
          to: '/dtp',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/dtp/compare-product/:key',
    name: 'dtp-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'DTP',
          to: '/dtp',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/dtp/casestudy/:key',
    name: 'product-dtp-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product by Category',
        },
        {
          text: 'DTP',
          to: '/dtp',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/product-portofolio/communication',
    name: 'product-category-communication',
    component: () => import('@/views/user/product/IndexCategory.vue'),
    meta: {
      pageTitle: 'Product By Portfolio',
      contentClass: 'product-category-communication',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/datacomm',
    name: 'product-category-datacomm',
    component: () => import('@/views/user/product/IndexCategory.vue'),
    meta: {
      pageTitle: 'Product By Portfolio',
      contentClass: 'product-category-datacomm',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/internet',
    name: 'product-category-internet',
    component: () => import('@/views/user/product/IndexCategory.vue'),
    meta: {
      pageTitle: 'Product By Portfolio',
      contentClass: 'product-category-internet',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/wireless',
    name: 'product-category-wireless',
    component: () => import('@/views/user/product/IndexCategory.vue'),
    meta: {
      pageTitle: 'Product By Portfolio',
      contentClass: 'product-category-wireless',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/cyber-security/detail/:key',
    name: 'product-cyber-security-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Cyber Security',
          to: '/product-portofolio/cyberSecurity',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/cyber-security/faq/:key',
    name: 'product-cyber-security-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Cyber Security',
          to: '/product-portofolio/cyberSecurity',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/cyber-security/compare-product/:key',
    name: 'cyber-security-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Cyber Security',
          to: '/product-portofolio/cyberSecurity',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/cyber-security/tarif/:key',
    name: 'product-cyber-security-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Cyber Security',
          to: '/product-portofolio/cyberSecurity',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/cyber-security/casestudy/:key',
    name: 'product-cyber-security-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Cyber Security',
          to: '/product-portofolio/cyberSecurity',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/product-portofolio/cyberSecurity',
    name: 'product-category-cyber-security',
    component: () => import('@/views/user/product/IndexCategory.vue'),
    meta: {
      pageTitle: 'Product By Portfolio',
      contentClass: 'product-category-cyber-security',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Cyber Security',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/product-retire',
    name: 'product-retirement',
    component: () => import('@/views/user/product/IndexRetire.vue'),
    meta: {
      pageTitle: 'Product Retire',
      breadcrumb: [
        {
          text: 'Product Retire',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product/detail/:key',
    name: 'product-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product Retire',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  // Communication
  {
    path: '/product-portofolio/communication/detail/:key',
    name: 'product-communication-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          to: '/product-portofolio/communication',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/communication/faq/:key',
    name: 'product-communication-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          to: '/product-portofolio/communication',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/communication/compare-product/:key',
    name: 'communication-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          to: '/product-portofolio/communication',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/communication/tarif/:key',
    name: 'product-communication-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          to: '/product-portofolio/communication',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/communication/casestudy/:key',
    name: 'product-communication-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          to: '/product-portofolio/communication',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/communication/zonaInner/:key',
    name: 'product-communication-zona-inner',
    component: () => import('@/views/user/product/ZonaInner.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Communication',
          to: '/product-portofolio/communication',
        },
        {
          text: 'Zona Tarif Inner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // Communication

  // Datacomm
  {
    path: '/product-portofolio/datacomm/detail/:key',
    name: 'product-datacomm-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          to: '/product-portofolio/datacomm',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/datacomm/faq/:key',
    name: 'product-datacomm-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          to: '/product-portofolio/datacomm',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/datacomm/compare-product/:key',
    name: 'datacomm-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          to: '/product-portofolio/datacomm',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/datacomm/tarif/:key',
    name: 'product-datacomm-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          to: '/product-portofolio/datacomm',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/datacomm/casestudy/:key',
    name: 'product-datacomm-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          to: '/product-portofolio/datacomm',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/datacomm/zonaInner/:key',
    name: 'product-datacomm-zona-inner',
    component: () => import('@/views/user/product/ZonaInner.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Datacomm',
          to: '/product-portofolio/datacomm',
        },
        {
          text: 'Zona Tarif Inner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // Datacomm

  // Internet
  {
    path: '/product-portofolio/internet/detail/:key',
    name: 'product-internet-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          to: '/product-portofolio/internet',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/internet/faq/:key',
    name: 'product-internet-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          to: '/product-portofolio/internet',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/internet/compare-product/:key',
    name: 'internet-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          to: '/product-portofolio/internet',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/internet/tarif/:key',
    name: 'product-internet-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          to: '/product-portofolio/internet',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/internet/casestudy/:key',
    name: 'product-internet-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          to: '/product-portofolio/internet',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/internet/zonaInner/:key',
    name: 'product-internet-zona-inner',
    component: () => import('@/views/user/product/ZonaInner.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Internet',
          to: '/product-portofolio/internet',
        },
        {
          text: 'Zona Tarif Inner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // Internet

  // Wireless
  {
    path: '/product-portofolio/wireless/detail/:key',
    name: 'product-wireless-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          to: '/product-portofolio/wireless',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/wireless/faq/:key',
    name: 'product-wireless-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          to: '/product-portofolio/wireless',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/wireless/compare-product/:key',
    name: 'wireless-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          to: '/product-portofolio/wireless',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/wireless/tarif/:key',
    name: 'product-wireless-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          to: '/product-portofolio/wireless',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/wireless/casestudy/:key',
    name: 'product-wireless-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          to: '/product-portofolio/wireless',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-portofolio/wireless/zonaInner/:key',
    name: 'product-wireless-zona-inner',
    component: () => import('@/views/user/product/ZonaInner.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By Portfolio',
        },
        {
          text: 'Wireless',
          to: '/product-portofolio/wireless',
        },
        {
          text: 'Zona Tarif Inner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // Wireless

  // stp
  // CFU
  {
    path: '/product-cfu/ebis',
    name: 'product-cfu-ebis',
    component: () => import('@/views/user/product/IndexCfu.vue'),
    meta: {
      pageTitle: 'Product By CFU',
      contentClass: 'product-cfu-ebis',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'EBIS',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/wibs',
    name: 'product-cfu-wibs',
    component: () => import('@/views/user/product/IndexCfu.vue'),
    meta: {
      pageTitle: 'Product By CFU',
      contentClass: 'product-cfu-wibs',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/cons',
    name: 'product-cfu-cons',
    component: () => import('@/views/user/product/IndexCfu.vue'),
    meta: {
      pageTitle: 'Product By CFU',
      contentClass: 'product-cfu-cons',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'CONS',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // CFU

  // CONS
  {
    path: '/product-cfu/cons/detail/:key',
    name: 'product-cfu-cons-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'CONS',
          to: '/product-cfu/cons',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/cons/faq/:key',
    name: 'product-cfu-cons-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'CONS',
          to: '/product-cfu/cons',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/cons/compare-product/:key',
    name: 'cons-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'CONS',
          to: '/product-cfu/cons',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/cons/tarif/:key',
    name: 'product-cons-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'CONS',
          to: '/product-cfu/cons',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/cons/casestudy/:key',
    name: 'product-cons-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'CONS',
          to: '/product-cfu/cons',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // CONS

  // WIBS
  {
    path: '/product-cfu/wibs/detail/:key',
    name: 'product-cfu-wibs-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/wibs',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/wibs/faq/:key',
    name: 'product-cfu-wibs-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/wibs',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/wibs/compare-product/:key',
    name: 'wibs-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/wibs',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/wibs/tarif/:key',
    name: 'product-wibs-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/wibs',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/wibs/casestudy/:key',
    name: 'product-wibs-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/wibs',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/wibs/zonaInner/:key',
    name: 'product-wibs-zona-inner',
    component: () => import('@/views/user/product/ZonaInner.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/wibs',
        },
        {
          text: 'Zona Tarif Inner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // WIBS

  // EBIS
  {
    path: '/product-cfu/ebis/detail/:key',
    name: 'product-cfu-ebis-detail',
    component: () => import('@/views/user/product/detail.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'EBIS',
          to: '/product-cfu/ebis',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/ebis/faq/:key',
    name: 'product-cfu-ebis-faq',
    component: () => import('@/views/user/product/Faq.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'EBIS',
          to: '/product-cfu/ebis',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/ebis/compare-product/:key',
    name: 'ebis-compare-product',
    component: () => import('@/views/user/product/CompareProduct.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'EBIS',
          to: '/product-cfu/ebis',
        },
        {
          text: 'Compare Product',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/ebis/tarif/:key',
    name: 'product-ebis-tarif',
    component: () => import('@/views/user/product/Tarif.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'EBIS',
          to: '/product-cfu/ebis',
        },
        {
          text: 'Tarif',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/ebis/casestudy/:key',
    name: 'product-ebis-casestudy',
    component: () => import('@/views/user/product/CaseStudy.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'EBIS',
          to: '/product-cfu/ebis',
        },
        {
          text: 'Case Study',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product-cfu/ebis/zonaInner/:key',
    name: 'product-ebis-zona-inner',
    component: () => import('@/views/user/product/ZonaInner.vue'),
    meta: {
      pageTitle: '',
      breadcrumb: [
        {
          text: 'Product By CFU',
        },
        {
          text: 'WIBS',
          to: '/product-cfu/ebis',
        },
        {
          text: 'Zona Tarif Inner',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  // EBIS

  //
  {
    path: '/product/search',
    name: 'product-search',
    component: () => import('@/views/user/product/SearchResult.vue'),
    meta: {
      pageTitle: 'Result',
      breadcrumb: [
        {
          text: 'Product',
        },
        {
          text: 'Result',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product/calculator/:kode',
    component: () => import('@/views/user/product/calculator/Index.vue'),
    children: [
      {
        path: 'cart',
        component: () => import('@/views/user/product/calculator/Cart.vue'),
        name: 'product-calculator',
        meta: {
          pageTitle: '',
          breadcrumb: [
            {
              text: 'Calculator',
              active: true,
            },
          ],
          requiresAuth: true,
        },
      },
      {
        path: 'total',
        component: () => import('@/views/user/product/calculator/Total.vue'),
        name: 'product-calculator-total',
        meta: {
          pageTitle: '',
          breadcrumb: [
            {
              text: 'Calculator',
              active: true,
            },
          ],
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: () => import('@/views/user/contact-us/Index.vue'),
    meta: {
      pageTitle: 'Contact Us',
      breadcrumb: [
        {
          text: 'Contact Us',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/consultative-selling',
    name: 'consultative-selling',
    component: () => import('@/views/user/consultative-selling/Index.vue'),
    meta: {
      pageTitle: 'Consultative Selling',
      breadcrumb: [
        {
          text: 'Consultative Selling',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/consultative-selling/reservation',
    name: 'consultative-selling-reservation',
    component: () =>
      import('@/views/user/consultative-selling/Reservation.vue'),
    meta: {
      pageTitle: 'Consultative Selling',
      breadcrumb: [
        {
          text: 'Consultative Selling',
          to: '/user/consultative-selling',
        },
        {
          text: 'Reservation',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/consultative-selling/reservation/callback/:status',
    name: 'consultative-selling-reservation-callback',
    component: () => import('@/views/user/consultative-selling/Callback.vue'),
    meta: {
      pageTitle: 'Consultative Selling',
      breadcrumb: [
        {
          text: 'Consultative Selling',
          to: '/user/consultative-selling',
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/consultative-selling/reservation/approved/:data',
    name: 'contactUs-user',
    component: () => import('@/views/user/consultative-selling/Approved.vue'),
    meta: {
      layout: 'full',
      requiresAuth: true,
    },
  },
  {
    path: '/consultative-selling/reservation/reschedule/:data',
    name: 'contactUs-user',
    component: () => import('@/views/user/consultative-selling/Reschedule.vue'),
    meta: {
      layout: 'full',
      requiresAuth: true,
    },
  },
  {
    path: '/news-detail/:slug',
    name: 'news-detail',
    component: () => import('@/views/user/home/news/DetailNews.vue'),
    meta: {
      pageTitle: 'News Detail',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/news',
    name: 'all-news',
    component: () => import('@/views/user/home/news/index.vue'),
    meta: {
      pageTitle: 'News',
      breadcrumb: [
        {
          text: 'Home',
          to: { name: 'home' },
        },
        {
          text: 'All News',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/pcc',
    name: 'list-pcc',
    component: () => import('@/views/user/pcc/Index.vue'),
    meta: {
      pageTitle: 'PCC',
      breadcrumb: [
        {
          text: 'PCC',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/pcc/:id',
    name: 'detail-pcc',
    component: () => import('@/views/user/pcc/Detail.vue'),
    meta: {
      pageTitle: 'PCC',
      breadcrumb: [
        {
          text: 'PCC',
          to: { name: 'list-pcc' },
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/zt-inner',
    name: 'list-zt-inner',
    component: () => import('@/views/user/pcc/Index.vue'),
    meta: {
      pageTitle: 'PCC',
      breadcrumb: [
        {
          text: 'PCC',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },

  {
    path: '/product/proposal/:id',
    name: 'product-proposal-index',
    component: () => import('@/views/user/product/proposal/index.vue'),
    meta: {
      pageTitle: 'Product Proposal',
      breadcrumb: [
        {
          text: 'Product Proposal',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
  {
    path: '/product/proposal/:id/create',
    name: 'product-proposal-create',
    component: () => import('@/views/user/product/proposal/form.vue'),
    meta: {
      pageTitle: 'Create Product Summary',
      breadcrumb: [
        {
          text: 'Product Proposal',
        },
        {
          text: 'Create Product Summary',
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
]
